!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (n = "undefined" != typeof globalThis ? globalThis : n || self).dayjs_plugin_localeData = e();
}(this, function () {
  "use strict";

  return function (n, e, t) {
    var r = e.prototype,
      o = function o(n) {
        return n && (n.indexOf ? n : n.s);
      },
      u = function u(n, e, t, r, _u) {
        var i = n.name ? n : n.$locale(),
          a = o(i[e]),
          s = o(i[t]),
          f = a || s.map(function (n) {
            return n.substr(0, r);
          });
        if (!_u) return f;
        var d = i.weekStart;
        return f.map(function (n, e) {
          return f[(e + (d || 0)) % 7];
        });
      },
      i = function i() {
        return t.Ls[t.locale()];
      },
      a = function a(n, e) {
        return n.formats[e] || function (n) {
          return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (n, e, t) {
            return e || t.slice(1);
          });
        }(n.formats[e.toUpperCase()]);
      },
      s = function s() {
        var n = this;
        return {
          months: function months(e) {
            return e ? e.format("MMMM") : u(n, "months");
          },
          monthsShort: function monthsShort(e) {
            return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
          },
          firstDayOfWeek: function firstDayOfWeek() {
            return n.$locale().weekStart || 0;
          },
          weekdays: function weekdays(e) {
            return e ? e.format("dddd") : u(n, "weekdays");
          },
          weekdaysMin: function weekdaysMin(e) {
            return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
          },
          weekdaysShort: function weekdaysShort(e) {
            return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
          },
          longDateFormat: function longDateFormat(e) {
            return a(n.$locale(), e);
          },
          meridiem: this.$locale().meridiem,
          ordinal: this.$locale().ordinal
        };
      };
    r.localeData = function () {
      return s.bind(this)();
    }, t.localeData = function () {
      var n = i();
      return {
        firstDayOfWeek: function firstDayOfWeek() {
          return n.weekStart || 0;
        },
        weekdays: function weekdays() {
          return t.weekdays();
        },
        weekdaysShort: function weekdaysShort() {
          return t.weekdaysShort();
        },
        weekdaysMin: function weekdaysMin() {
          return t.weekdaysMin();
        },
        months: function months() {
          return t.months();
        },
        monthsShort: function monthsShort() {
          return t.monthsShort();
        },
        longDateFormat: function longDateFormat(e) {
          return a(n, e);
        },
        meridiem: n.meridiem,
        ordinal: n.ordinal
      };
    }, t.months = function () {
      return u(i(), "months");
    }, t.monthsShort = function () {
      return u(i(), "monthsShort", "months", 3);
    }, t.weekdays = function (n) {
      return u(i(), "weekdays", null, null, n);
    }, t.weekdaysShort = function (n) {
      return u(i(), "weekdaysShort", "weekdays", 3, n);
    }, t.weekdaysMin = function (n) {
      return u(i(), "weekdaysMin", "weekdays", 2, n);
    };
  };
});